import React from 'react'
import {AiFillStar} from 'react-icons/ai'

const ReviewForm = () => {
    return (
        <div className="w-full md:border-2 md:border-ash  md:p-4 lg:p-8">
        <div className="flex flex-col  ">
            {/* *****************LEFT PART */}
            <div>
               <div className="flex flex-col w-full">
                <h1 className="text-base font-bold mb-2 text-black">Add a Review</h1>   
                <div className="flex  space-x-4 mb-6">
                <div className="flex items-center st-container space-x-1">
                <AiFillStar className="text-light-star text-base" />
                <AiFillStar className="text-light-star text-base" />
                <AiFillStar className="text-light-star text-base" />
                <AiFillStar className="text-light-star text-base" />
                <AiFillStar className="text-light-star text-base" />
                </div>
                <p className="text-sm text-gray-600">Your Rating</p>
                </div>
                </div>
                {/* end of star ratings */}
                {/* review input */}
                <div className=" flex flex-col md:flex-row space-x-6">
            <div className=" w-full md:w-4/12 lg:w-3/12">

                <div className=" flex flex-col space-y-2">
                <label className="text-sm font-bold text-gray-600">Your Name</label>
                <input type="text" className="w-full bg-light-blue  p-2" placeholder="Name"/>
                </div>
                <div className=" flex flex-col space-y-2 mt-2">
                <label className="text-sm font-bold text-gray-600">Your Email</label>
                <input type="text" className="w-full bg-light-blue  p-2" placeholder="Email"/>
                </div>
                {/* end of review input */}
                {/* checkbox session */}
                <div className="flex mt-4 mb-4 ">
                <input type="checkbox" className="mr-2" />
                <p className="text-sm text-gray-600 truncate">Save my name, email, and <br /> website  in this browser for the next time I comment.</p>
                </div>
                </div>

                {/* **********RIHT PART */}
            <div className="w-full md:w-8/12 lg:w-9/12">
            <div className=" flex flex-col space-y-2">
                <label className="text-sm font-bold text-gray-600">Your Name</label>
                <textarea className="w-11/12  bg-light-blue  p-2 h-32" placeholder="Your Review"></textarea>
                <button className="w-fit md:w-5/12 bg-tradr-green text-white font-bold py-2 px-4 mt-4">Submit Review</button>

                {/* <in type="text" className="w-full bg-light-blue  p-2" placeholder="Name"/> */}
                </div>

             </div> 
             </div>

             </div>
        </div>
        
        </div>
    )
}

export default ReviewForm